import { render, staticRenderFns } from "./MergeImpactSummary.vue?vue&type=template&id=6fe6e25c"
import script from "./MergeImpactSummary.vue?vue&type=script&lang=js"
export * from "./MergeImpactSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports